import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NewCheckIn = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState('');
    const [currentLocation, setCurrentLocation] = useState('Getting location...');
    const [locationName, setLocationName] = useState("Getting location...");
    const [loading, setLoading] = useState(false);
    const scrollViewRef = useRef(null);

    // Form data
    const [pinCode, setPinCode] = useState('');
    const [reason, setReason] = useState('');

    // Error states
    const [pinCodeError, setPinCodeError] = useState('');
    const [reasonError, setReasonError] = useState('');

    useEffect(() => {
        const initializeUser = async () => {
            const phoneNumber = localStorage.getItem('phNumber');
            setUser(phoneNumber);
        };

        initializeUser();
    }, []);


    const validateForm = () => {
        let isValid = true;

        // Reset all errors
        setPinCodeError('');
        setReasonError('');

        if(currentLocation === 'Getting location...') {
            alert("Please wait getting for location!");
        }

        // Validate pin code (optional, but if provided should be 6 digits)
        if (pinCode.trim() && pinCode.length !== 6) {
            setPinCodeError('Pincode must be exactly 6 digits');
            isValid = false;
        }

        // Validate reason
        if (!reason.trim()) {
            setReasonError('For What is required!');
            isValid = false;
        }

        return isValid;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            const response = await fetch('https://shakticlub-backend.vercel.app/api/v1/checkin/create_checkin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: user,
                    location: currentLocation,
                    pinCode: pinCode.trim(),
                    reason: reason.trim()
                }),
            });

            const data = await response.json();

            if (response.ok) {
                alert('Check-in created successfully!');
                navigate("/user_dashboard")
            } else {
                throw new Error(data.message || 'Failed to create check-in');
            }
        } catch (error) {
            console.error('Error submitting check-in:', error);
            alert(`Failed to create check-in. ${error}`);
        } finally {
            setLoading(false);
        }
    };

    const clearFieldError = (field) => {
        switch (field) {
            case 'pinCode':
                setPinCodeError('');
                break;
            case 'reason':
                setReasonError('');
                break;
        }
    };

    const handlePinCodeChange = (e) => {
        const text = e.target.value;
        const cleanText = text.replace(/[^0-9]/g, '').slice(0, 6);
        setPinCode(cleanText);
        clearFieldError('pinCode');
    };

    const handleReasonChange = (e) => {
        setReason(e.target.value);
        clearFieldError('reason');
    };

    useEffect(() => {
        trackLocation();
    }, []);

    const trackLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setCurrentLocation(`${latitude}, ${longitude}`);
                },
                (error) => console.error("Error fetching location:", error.message),
                { enableHighAccuracy: true, timeout: 10000 }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    };

    useEffect(() => {
        const processLocationNames = async () => {
            if(currentLocation !== 'Getting location...'){
                const coords = currentLocation.split(',');
                console.log(coords);
                const locationName = await getLocationName(
                    Number(coords[0]),
                    Number(coords[1]?.trim())
                );
                setLocationName(locationName);
            }
        }
        processLocationNames();
    }, [currentLocation])

    const getLocationName = async (latitude, longitude) => {
        try {
            // Using a reverse geocoding service (you might need to replace with your preferred service)
            const response = await fetch(`https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=27f9e4df28784bee86cb0b8f0d1345c6`);
            const data = await response.json();
            if (data.results && data.results[0]) {
                const place = data.results[0].components;
                return `${place.village || place.road}, ${place.city || place.town || place.state_district}, ${place.state || place.region}`;
            }
        } catch (error) {
            console.error('Error getting location name:', error);
        }
        return 'Unknown location';
    };

    return (
        <div className="flex-1 bg-white min-h-screen">
            {/* Title Section */}
            <div className="px-6 pt-3 mb-6">
                <h1 className="text-gray-800 font-bold text-2xl leading-8 text-left mb-3">
                    Check-In
                </h1>
            </div>

            {/* Content */}
            <div
                ref={scrollViewRef}
                className="flex-1 px-6 pb-10 overflow-y-auto"
            >
                <div className="flex-1">
                    {/* Current Location Display */}
                    <div className="w-full mb-5">
                        <label className="text-gray-800 font-bold text-sm mb-3 block">
                            Current Location
                        </label>
                        <div
                            className="bg-gray-100 border border-gray-200 rounded-lg px-4 py-5 flex items-center"
                            style={{ backgroundColor: '#F5F5F5' }}
                        >
                            <span className="text-sm text-gray-800">
                                {locationName || 'Getting location...'}
                            </span>
                        </div>
                    </div>

                    {/* Pin Code (Optional) */}
                    <div className="w-full mb-5">
                        <label className="text-gray-800 font-bold text-sm mb-3 block">
                            Pincode (Optional)
                        </label>
                        <input
                            type="text"
                            className={`w-full bg-white border rounded-lg px-4 py-5 text-sm text-gray-800 ${pinCodeError ? 'border-red-500 border-2' : 'border-gray-200'
                                }`}
                            style={{ borderColor: pinCodeError ? '#f73d3d' : '#E7EAEB' }}
                            value={pinCode}
                            onChange={handlePinCodeChange}
                            placeholder="Enter pincode"
                            maxLength={6}
                        />
                        {pinCodeError && (
                            <p className="text-red-500 text-xs mt-1">{pinCodeError}</p>
                        )}
                    </div>

                    {/* Reason */}
                    <div className="w-full mb-8">
                        <label className="text-gray-800 font-bold text-sm mb-3 block">
                            For What?
                        </label>
                        <textarea
                            className={`w-full bg-white border rounded-lg px-4 py-5 text-sm text-gray-800 resize-none ${reasonError ? 'border-red-500 border-2' : 'border-gray-200'
                                }`}
                            style={{
                                borderColor: reasonError ? '#f73d3d' : '#E7EAEB',
                                height: '120px'
                            }}
                            value={reason}
                            onChange={handleReasonChange}
                            placeholder="Enter for what you come here?"
                            rows={5}
                        />
                        {reasonError && (
                            <p className="text-red-500 text-xs mt-1">{reasonError}</p>
                        )}
                    </div>

                    {/* Submit Button */}
                    <button
                        className="w-full rounded-2xl flex items-center justify-center py-4 transition-opacity duration-200"
                        style={{
                            backgroundColor: '#4A50FF',
                            opacity: loading ? 0.6 : 1
                        }}
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                        ) : (
                            <span className="text-white font-bold text-base">
                                Check-In
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewCheckIn;